export class Scenario {
    public gender: string;
    public zone: string;
    public skinType: string;
    public concern: string;
    public treatment: string;
    public age: string;
    public ageProblems: string;
    public sun: string;

    
    public sculpSkin: string;  
    
    public sculpConcern: string;
    public sunAdultOrKid: string; 

    public sunZone: string; 
    public sunSkinType: string; 
    public sunConcern: string; 

    public productIdList: any;
}

export class ExceptingScenario {    
    public gender: string;
    public howOld: string;
    public path: string;
    public productIdList: string;
}

export class ScenarioPart {
    public question: string;
    public answers: any;
    public parent: ScenarioPart;
}



// WEBPACK FOOTER //
// ./src/models/scenario.ts